import React from 'react';
import { Section } from './ui/Section';
import { CheckCircleIcon, XCircleIcon } from 'lucide-react';
export function ForWhom() {
  return <Section data-id="element-60">
      <div className="grid md:grid-cols-2 gap-12 max-w-5xl mx-auto" data-id="element-61">
        {/* For You */}
        <div className="bg-green-50/50 p-8 md:p-10 rounded-3xl border border-green-100" data-id="element-62">
          <h3 className="text-2xl font-bold text-stone-900 mb-8 flex items-center" data-id="element-63">
            <span className="bg-green-100 text-green-700 p-2 rounded-lg mr-3" data-id="element-64">
              <CheckCircleIcon className="h-6 w-6" data-id="element-65" />
            </span>
            Esto es para ti si...
          </h3>
          <ul className="space-y-4" data-id="element-66">
            {["Te abruma 'no saber qué preguntar'", 'Quieres resultados prácticos en 48 horas', 'Eres emprendedor y necesitas escribir/contestar rápido', 'Prefieres plantillas listas en vez de teoría'].map((item, i) => <li key={i} className="flex items-start" data-id="element-67">
                <CheckCircleIcon className="h-5 w-5 text-green-600 mr-3 mt-0.5 flex-shrink-0" data-id="element-68" />
                <span className="text-stone-700" data-id="element-69">{item}</span>
              </li>)}
          </ul>
        </div>

        {/* Not For You */}
        <div className="bg-stone-50 p-8 md:p-10 rounded-3xl border border-stone-200" data-id="element-70">
          <h3 className="text-2xl font-bold text-stone-900 mb-8 flex items-center" data-id="element-71">
            <span className="bg-stone-200 text-stone-600 p-2 rounded-lg mr-3" data-id="element-72">
              <XCircleIcon className="h-6 w-6" data-id="element-73" />
            </span>
            Esto NO es para ti si...
          </h3>
          <ul className="space-y-4" data-id="element-74">
            {['Quieres programar modelos o aprender machine learning', "Buscas 'hackear' cosas o promesas irreales", 'No quieres practicar 30–45 minutos en dos días', 'Buscas una solución mágica sin poner de tu parte'].map((item, i) => <li key={i} className="flex items-start" data-id="element-75">
                <XCircleIcon className="h-5 w-5 text-stone-400 mr-3 mt-0.5 flex-shrink-0" data-id="element-76" />
                <span className="text-stone-600" data-id="element-77">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </Section>;
}